// src/constants/tableLabels.js
//
// `full` is the backend key - it must match table_name in sap_modules.json
// exactly, because the backend compares this string directly. `short` is the
// collapsed chip label and `label` (optional) is what the expanded chip shows
// instead of the raw table name; when `label` is absent the chip falls back to
// `full`, which is why the older entries below still read as SAP table names.

const tableLabels = {
    'Business Partner': [
      { short: 'Cust', full: 'Customer' },
      { short: 'BP', full: 'Business Partner' },
      { short: 'Sup', full: 'Supplier' },
    ],
    'Sales Order': [
      { short: 'SO', full: 'SalesOrder' },
      { short: 'Item', full: 'SalesOrderItem' },
      // { short: 'Line', full: 'Schedule Line' },
    ],
    'Cost Center':[
      { short: 'CostMaster', full: 'CostCenterMaster' },
      { short: 'GLMaster', full: 'GLAccountMaster' },

    ],
    'Inventory':[
      { short: 'Material', full: 'MaterialDocumentHeader' },
      { short: 'Matitem', full: 'MaterialDocumentitem' },
      { short: 'MatStock', full: 'Material_stock_information' },
      { short: 'PhyInv', full: 'PhysicalInventoryDocumentHeader' },
      // Must match table_name in sap_modules.json exactly - the backend compares
      // this string directly. It read 'PhysInventoryDocumentItem' and never matched.
      { short: 'PhyInvitem', full: 'PhysicalInventoryDocumentItem' },
    ],
    'Vendor':[
      { short: 'Vendor', full: 'VendorMaster', label: 'Vendor' },
      { short: 'Status', full: 'Supplier', label: 'Vendor Status' },
    ],
    'Purchase Orders':[
      { short: 'Header', full: 'PurchaseOrder', label: 'PO Header' },
      { short: 'Item', full: 'PurchaseOrderItem', label: 'PO Item' },
      { short: 'Schedule', full: 'PurchaseOrderScheduleLines', label: 'Schedule Line' },
      { short: 'Pricing', full: 'PurchaseOrderPricing', label: 'Pricing' },
    ],
    'Purchase Requisition':[
      {short:'Item',full:'PurchaseRequisitionItem', label:'PR Item'},
      {short:'Header',full:'PurchaseRequisitionHeader', label:'PR Header'}
    ],
    'Goods Movement':[
      // full stays 'GRN' - it is the backend table_name and the key in
      // UPLOADABLE_TABLES / DOC_CONFIG that switches on the GRN upload.
      {short:'GR',full:'GRN', label:'Goods Receipt'},
      {short:'Header',full:'MaterialDocumentHeader', label:'GR Header'}
    ],


    'Human Resource': [
      { short: 'ALL', full: 'All functions' },
      
    ],
    'Policy Repository': [{ full: 'Documents', short: 'Docs' }],
    'Analytics': [{full: 'Finance Reports', short: 'Reports' },
    ],
    'Finance Analyst': [{full: 'Finance Analyst', short: 'Analyst' }],
    'Vendor Invoice':[{full:'VendorInvoice',short:'Invoice',label:'Invoice'},
      {full:'VendorInvoiceItem',short:'Item',label:'Invoice Item'},
      {full:'direct_post',short:'FB60',label:'Direct Post (FB60)'}
    ],
    'Vendor Ledger':[
      {full:'accounting',short:'Ledger',label:'Vendor Ledger'}
    ],
    'Palmtop':[{full:'master_plan',short:'Master Plan'}]
  };
  
  export default tableLabels;
  